export default "__VITE_ASSET__DVJRevVh__"